<div class="dlg-responsive">
    <div class="dlg-responsive-content">
        <ng-content />
    </div>
</div>
